import React, { useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";
import EditorialCard from "@/components/EditorialCard";
import SectionHeader from "@/components/SectionHeader";
import api from "@/lib/api";

const NewsListPage = () => {
  const [items, setItems] = useState([]);
  const [category, setCategory] = useState("All");

  useEffect(() => { (async () => setItems(await api.news()))(); }, []);

  const categories = useMemo(() => ["All", ...Array.from(new Set(items.map((i) => i.category)))], [items]);
  const filtered = category === "All" ? items : items.filter((i) => i.category === category);

  return (
    <div data-testid="news-list-page">
      <section className="pt-16 md:pt-24 pb-10 max-w-[1440px] mx-auto px-5 md:px-10">
        <SectionHeader
          overline="News Desk"
          title="A daily digest of what matters."
          lede="Verified developments across business, technology, policy and finance — reported without noise or sensational framing."
        />
      </section>

      <section className="max-w-[1440px] mx-auto px-5 md:px-10 pb-10">
        <div className="flex flex-wrap gap-2" data-testid="news-category-filter">
          {categories.map((c) => (
            <button
              key={c}
              onClick={() => setCategory(c)}
              data-testid={`news-filter-${c.toLowerCase().replace(/\s+/g,"-")}`}
              className={`px-4 py-2 text-[11px] font-mono-editorial uppercase tracking-[0.22em] border transition-all rounded-full ${
                category === c ? "bg-ink text-paper border-ink" : "text-ink-soft border-ink-line hover:border-ink hover:text-ink"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </section>

      <section className="max-w-[1440px] mx-auto px-5 md:px-10 pb-24 md:pb-32">
        <motion.div layout className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="news-grid">
          {filtered.map((n) => (
            <EditorialCard
              key={n.id}
              overline={n.category}
              title={n.title}
              excerpt={n.summary}
              image={n.image}
              meta={`${new Date(n.date).toLocaleDateString(undefined,{month:"short",day:"numeric",year:"numeric"})} · ${n.read_time}`}
              href={`/news/${n.slug}`}
              testId={`news-card-${n.slug}`}
            />
          ))}
        </motion.div>
      </section>
    </div>
  );
};

export default NewsListPage;
